import "./FindAddFunctionality.html";
import "./FindFunctionalityResultTemplate.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import FindAddFunctionalityComponentController from "./FindAddFunctionalityComponentController";

export class FindAddFunctionalityComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            addedFunctionalities: "<",
            canAddFunctionality: "<",
            clearAfterAdd: "<",
            hideTitle: "<",
            newFunctionality: "&?",
            selectFunctionality: "&?",
        };
        this.controller = FindAddFunctionalityComponentController;
        this.templateUrl =
            "/App/Components/EquipmentType/" +
            "EquipmentFunctionalities/FindAddFunctionality/FindAddFunctionality.html";
    }
}

module("mmManagePortal").component("irFindAddFunctionalityType", new FindAddFunctionalityComponent());
